import { useState, useEffect } from "react";

const KEY = "bsg_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-50 glass-card p-5 shadow-xl">
      <p className="text-sm text-muted leading-relaxed">
        We use cookies to improve your experience. By continuing, you agree to our cookie policy.
      </p>
      <button
        type="button"
        onClick={accept}
        className="mt-4 btn-gold !py-2 !px-5 text-sm"
      >
        Accept
      </button>
    </div>
  );
}
